import _ from 'lodash';
import * as t from './actionTypes';

const defaultState = {
  data: {},
  isLoading: false,
  error: null,
};

const organizationMembersReducer = (state = defaultState, action) => {
  switch (action.type) {
    /*-------------------------------------------------------------------------------*/
    /* MEMBERS                                                                       */
    /*-------------------------------------------------------------------------------*/

    // FETCH_ORGANIZATION_MEMBERS
    case t.FETCH_ORGANIZATION_MEMBERS_REQUEST: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case t.FETCH_ORGANIZATION_MEMBERS_RESPONSE: {
      return {
        ...state,
        isLoading: false,
        data: _.keyBy(action.payload.members, 'userId'),
      };
    }
    case t.FETCH_ORGANIZATION_MEMBERS_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    }

    // CREATE_ORGANIZATION_MEMBER
    case t.CREATE_ORGANIZATION_MEMBER_REQUEST: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case t.CREATE_ORGANIZATION_MEMBER_RESPONSE: {
      return {
        ...state,
        isLoading: false,
        data: {
          ...state.data,
          [action.payload.userId]: action.payload,
        },
      };
    }
    case t.CREATE_ORGANIZATION_MEMBER_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    }

    // UPDATE_ORGANIZATION_MEMBER
    case t.UPDATE_ORGANIZATION_MEMBER_REQUEST: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case t.UPDATE_ORGANIZATION_MEMBER_RESPONSE: {
      return {
        ...state,
        isLoading: false,
        data: {
          ...state.data,
          [action.payload.userId]: action.payload,
        },
      };
    }
    case t.UPDATE_ORGANIZATION_MEMBER_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    }

    // UPDATE_ORGANIZATION_MEMBERSHIP
    case t.UPDATE_ORGANIZATION_MEMBERSHIP_REQUEST: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case t.UPDATE_ORGANIZATION_MEMBERSHIP_RESPONSE: {
      return {
        ...state,
        isLoading: false,
        data: {
          ...state.data,
          [action.payload.userId]: action.payload,
        },
      };
    }
    case t.UPDATE_ORGANIZATION_MEMBERSHIP_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    }
    default:
      return state;
  }
};

const organizationProjectsReducer = (state = defaultState, action) => {
  switch (action.type) {
    /*-------------------------------------------------------------------------------*/
    /* PROJECTS                                                                      */
    /*-------------------------------------------------------------------------------*/

    // FETCH_ORGANIZATION_PROJECTS
    case t.FETCH_ORGANIZATION_PROJECTS_REQUEST: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case t.FETCH_ORGANIZATION_PROJECTS_RESPONSE: {
      return {
        ...state,
        isLoading: false,
        data: _.keyBy(action.payload, 'id'),
      };
    }
    case t.FETCH_ORGANIZATION_PROJECTS_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    }
    default:
      return state;
  }
};

const organizationRolesReducer = (state = defaultState, action) => {
  switch (action.type) {
    /*-------------------------------------------------------------------------------*/
    /* ROLES                                                                         */
    /*-------------------------------------------------------------------------------*/

    // FETCH_ORGANIZATION_ROLES
    case t.FETCH_ORGANIZATION_ROLES_REQUEST: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case t.FETCH_ORGANIZATION_ROLES_RESPONSE: {
      return {
        ...state,
        isLoading: false,
        data: _.keyBy(action.payload, 'id'),
      };
    }
    case t.FETCH_ORGANIZATION_ROLES_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    }

    // CREATE_ORGANIZATION_ROLE
    case t.CREATE_ORGANIZATION_ROLE_REQUEST: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case t.CREATE_ORGANIZATION_ROLE_RESPONSE: {
      return {
        ...state,
        isLoading: false,
        data: {
          ...state.data,
          [action.payload.id]: action.payload,
        },
      };
    }
    case t.CREATE_ORGANIZATION_ROLE_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    }

    // UPDATE_ORGANIZATION_ROLE
    case t.UPDATE_ORGANIZATION_ROLE_REQUEST: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case t.UPDATE_ORGANIZATION_ROLE_RESPONSE: {
      return {
        ...state,
        isLoading: false,
        data: {
          ...state.data,
          [action.payload.id]: action.payload,
        },
      };
    }
    case t.UPDATE_ORGANIZATION_ROLE_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    }
    default:
      return state;
  }
};

const organizationTeamsReducer = (state = defaultState, action) => {
  switch (action.type) {
    /*-------------------------------------------------------------------------------*/
    /* TEAMS                                                                         */
    /*-------------------------------------------------------------------------------*/

    // FETCH_ORGANIZATION_TEAMS
    case t.FETCH_ORGANIZATION_TEAMS_REQUEST: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case t.FETCH_ORGANIZATION_TEAMS_RESPONSE: {
      return {
        ...state,
        isLoading: false,
        data: _.keyBy(action.payload, 'id'),
      };
    }
    case t.FETCH_ORGANIZATION_TEAMS_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    }

    default:
      return state;
  }
};

const organizationPermissionsReducer = (state = defaultState, action) => {
  switch (action.type) {
    /*-------------------------------------------------------------------------------*/
    /* PERMISSIONS                                                                   */
    /*-------------------------------------------------------------------------------*/

    // FETCH_PERMISSIONS
    case t.FETCH_PERMISSIONS_REQUEST: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case t.FETCH_PERMISSIONS_RESPONSE: {
      return {
        ...state,
        isLoading: false,
        data: _.keyBy(action.payload, 'id'),
      };
    }
    case t.FETCH_PERMISSIONS_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    }

    default:
      return state;
  }
};

const organizationDeliveryTargetsReducer = (state = defaultState, action) => {
  switch (action.type) {
    /*-------------------------------------------------------------------------------*/
    /* DELIVERY TARGETS                                                              */
    /*-------------------------------------------------------------------------------*/

    // FETCH_DELIVERY_TARGETS
    case t.FETCH_DELIVERY_TARGETS_REQUEST: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case t.FETCH_DELIVERY_TARGETS_RESPONSE: {
      return {
        ...state,
        isLoading: false,
        data: _.keyBy(action.payload, 'id'),
      };
    }
    case t.FETCH_DELIVERY_TARGETS_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    }

    // CREATE_DELIVERY_TARGET
    case t.CREATE_DELIVERY_TARGET_REQUEST: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case t.CREATE_DELIVERY_TARGET_RESPONSE: {
      return {
        ...state,
        isLoading: false,
        data: {
          ...state.data,
          [action.payload.id]: action.payload,
        },
      };
    }
    case t.CREATE_DELIVERY_TARGET_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    }

    // UPDATE_DELIVERY_TARGET
    case t.UPDATE_DELIVERY_TARGET_REQUEST: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case t.UPDATE_DELIVERY_TARGET_RESPONSE: {
      return {
        ...state,
        isLoading: false,
        data: {
          ...state.data,
          [action.payload.id]: action.payload,
        },
      };
    }
    case t.UPDATE_DELIVERY_TARGET_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    }
    default:
      return state;
  }
};

export {
  organizationMembersReducer,
  organizationProjectsReducer,
  organizationRolesReducer,
  organizationTeamsReducer,
  organizationPermissionsReducer,
  organizationDeliveryTargetsReducer,
};
